import React from 'react'
import {Badge, ImageBuffer, SubHeader} from '../..'
import { director } from '../../../assets'
import { newsEventsList } from '../../../utils/constants'
import { CheckRounded } from '@mui/icons-material'

import './meetOurTeam.css'

const MeetOurTeam = () => {
  return (
    <>
        <div id='meet-our-team' className='meet-our-team-wrapper'>
            <Badge title="Managing Director" />
            <SubHeader title="" description="" />

            <div className='meet-our-team-container'>
                <div className='meet-our-team-main'>
                    <div className='meet-our-team-image'>
                        <ImageBuffer src={director} alt='Managing Director' />
                    </div>
                    <div className='meet-our-team-gradient'></div>
                    <div className='meet-our-team-cover'>
                        <h3 className='meet-our-team-name'>Miriam Ofula</h3>
                        <div className="meet-our-team-details"></div>
                    </div>
                </div>

                <div className='news-events-service-container'>
                    <div className='news-events-service-main-container'>
                        <h3>Check out our latest news and events.</h3>
                        <div className="news-events-service-main-cover">
                            {newsEventsList.map((result, index) => {
                            return(
                                <div key={index} className="news-events-service-main-box">
                                <span className="news-events-service-main-grid">
                                    <CheckRounded />
                                </span>
                                <span className="news-events-service-main-text">{result.title}</span>
                                </div>
                            )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default MeetOurTeam